import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employee-default-layout',
  templateUrl: './employee-default-layout.component.html',
  styleUrls: ['./employee-default-layout.component.scss']
})
export class EmployeeDefaultLayoutComponent implements OnInit {
  currentPage = "";
  constructor() { }

  ngOnInit(): void {
  }

}
